import React, {useState} from 'react';
import {Button, message, Modal} from 'antd';
import {CopyOutlined, FileExcelOutlined} from '@ant-design/icons';
import {useNavigate, useLocation} from 'react-router-dom';
import {t} from '../../../../i18n';
import {DELIVERY_DOWNLOAD_FROM_ASYNC_DASHBOARD_STATE_KEY} from '../../../../constants/deliveryDownloadNavigation';

interface ParcelsDownloadModalProps {
    visible: boolean;
    onClose: () => void;
    fileName: string;
}

const ParcelsDownloadModal: React.FC<ParcelsDownloadModalProps> = ({
                                                                       visible,
                                                                       onClose,
                                                                       fileName,
                                                                   }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [copyLoading, setCopyLoading] = useState(false);

    const handleCopyFileName = async () => {
        setCopyLoading(true);
        try {
            await navigator.clipboard.writeText(fileName);
            message.success(t('delivery.parcels.message.downloadCopySuccess'));
        } catch (error) {
            message.error(t('delivery.parcels.message.downloadCopyFailed'));
        } finally {
            setCopyLoading(false);
        }
    };

    const handleGoToDownloadPage = () => {
        const path = location.pathname;
        if (path.includes('/qualitycontrol')) {
            navigate('/qualitycontrol/download');
        } else if (path.startsWith('/delivery')) {
            navigate('/delivery/download', {
                state: { [DELIVERY_DOWNLOAD_FROM_ASYNC_DASHBOARD_STATE_KEY]: true },
            });
        } else if (path.startsWith('/wms')) {
            navigate('/wms/download');
        } else {
            navigate('/central/download');
        }
        onClose();
    };

    return (
        <Modal
            title={
                <div className="flex items-center">
                    <div className="w-1 h-6 bg-purple-500 mr-3"></div>
                    <span className="text-lg font-medium">{t('delivery.parcels.title.downloadReport')}</span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            width={600}
            footer={[
                <Button key="close" onClick={onClose}>
                    {t('components.button.close')}
                </Button>,
                <Button key="copy" icon={<CopyOutlined/>} loading={copyLoading} onClick={handleCopyFileName}>
                    {t('components.button.copyFilename')}
                </Button>,
                <Button key="download" type="primary" onClick={handleGoToDownloadPage}>
                    {t('components.button.goToDownloadPage')}
                </Button>
            ]}
        >
            <div className="py-4">
                <p className="text-gray-800 font-medium mb-4">
                    {t('delivery.parcels.message.downloadDescription')}
                </p>
                <div className="bg-gray-50 p-3 rounded-lg mb-4">
                    <span className="font-medium">{t('delivery.parcels.label.filename')}: </span>
                    <code className="break-all">{fileName}</code>
                </div>
            </div>
        </Modal>
    );
};

export default ParcelsDownloadModal;

